<template>
    <div class="md-layout md-alignment-center-center md-size-90">
        <div class="md-layout md-layout-item md-alignment-center-center md-size-90">
            <div class="md-layout md-layout-item md-alignment-center-left">
                <span class="md-ml-3 md-primary">{{contentRange | contentRangeText}}</span>
            </div>
            <div class="md-layout md-layout-item md-alignment-center-right">
                <md-button class="md-mr-3 md-primary" @click="$emit('more')">Suivant<md-icon>keyboard_arrow_right</md-icon></md-button>
            </div>
        </div>
    </div>
</template>

<style scoped>
    span.md-primary {
        color: var(--md-theme-default-primary, #448aff) !important;
    }
</style>

<script>
    export default {
        name: 'partial-list-navigation',
        props: ['response'],
        computed: {
            contentRange: function () {
                if (this.response) {
                    return this.response.headers.get('Content-Range');
                }
            }
        }
    }
</script>